import React from "react";
import { useNavigate } from "react-router-dom";
import { FiLock, FiArrowLeft } from "react-icons/fi";

const NoAccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900 px-6">
      <div className="max-w-md w-full text-center bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-10">
        
        <div className="mx-auto w-20 h-20 flex items-center justify-center rounded-full bg-red-100 mb-6">
          <FiLock className="text-red-600 text-3xl" />
        </div>

        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          Access Restricted
        </h1>

        <p className="text-slate-600 mb-8">
          You don’t have permission to view this page.  
          Please contact your administrator if you believe this is a mistake.
        </p>

        <button
          onClick={() => navigate(-1)}
          className="w-full flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-slate-800 text-white py-3 font-semibold shadow-lg hover:scale-[1.02] active:scale-[0.98] transition"
        >
          <FiArrowLeft />
          Go Back
        </button>

      </div>
    </div>
  );
};

export default NoAccess;
